import isBot from "isbot";

export function isBotUserAgent() {
  return typeof navigator === "undefined" ? false : isBot(navigator.userAgent);
}
